import React from 'react';

export const SidebarThemeContext = React.createContext({
  itemTextColor: '',
  itemBackground: '',
  itemHoverBackground: '',
});
